import { Reveal, Stagger, StaggerItem } from "@/components/Reveal";

const STORIES = [
  {
    quote: "Our home loan moved from 9.1% to 7.40% without us chasing a single bank. The advisor did the running — we just signed where shown.",
    name: "Rohan & Aditi Kulkarni",
    meta: "Pune · Home Loan Balance Transfer",
  },
  {
    quote: "As a first-generation business owner, banks felt like closed rooms. Loan Salaah knew exactly which door would open for my profile.",
    name: "Farah Sheikh",
    meta: "Mumbai · Business Loan",
  },
  {
    quote: "₹1.2 crore against our property, structured in eleven days. Calm, precise, no surprises — that's all you want at this size.",
    name: "Vikram Reddy",
    meta: "Hyderabad · Loan Against Property",
  },
  {
    quote: "They advised me not to take the bigger loan I asked for. That's the moment I decided to trust them with the smaller one.",
    name: "Meera Nair",
    meta: "Bengaluru · Personal Loan",
  },
];

export const Testimonials = () => (
  <section data-testid="testimonials-section" className="py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal className="max-w-2xl">
        <div className="flex items-center gap-4">
          <span className="brass-rule" aria-hidden="true" />
          <span className="font-mono text-[0.65rem] uppercase tracking-[0.3em] text-brass">Borrower stories</span>
        </div>
        <h2 className="mt-5 font-serif text-3xl font-semibold tracking-tight text-concordia sm:text-4xl lg:text-5xl">
          Confidence, in their words.
        </h2>
      </Reveal>

      <Stagger className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-4" gap={0.09}>
        {STORIES.map((s) => (
          <StaggerItem key={s.name}>
            <figure
              data-testid={`testimonial-${s.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="flex h-full flex-col justify-between rounded-3xl border border-sand bg-white p-7 transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_28px_60px_rgba(30,74,61,0.12)]"
            >
              <div>
                <span className="font-serif text-5xl leading-none text-brass" aria-hidden="true">&ldquo;</span>
                <blockquote className="mt-2 text-sm leading-relaxed text-charcoal/85">{s.quote}</blockquote>
              </div>
              <figcaption className="mt-6 border-t border-sand/70 pt-4">
                <p className="text-sm font-semibold text-concordia">{s.name}</p>
                <p className="mt-1 font-mono text-[0.62rem] uppercase tracking-[0.18em] text-slate">{s.meta}</p>
              </figcaption>
            </figure>
          </StaggerItem>
        ))}
      </Stagger>
      <p className="mt-6 text-xs italic text-slate/70">
        Real Loan Salaah customer experiences.
      </p>
    </div>
  </section>
);
